<template>

    <div v-show="currentStep >= 1"
         class="cursor-default flex items-center justify-center w-[12.5%] px-1 sm:px-2 lg:px-5 border-r-2 border-red-3">
        <div class="text-white font-semibold">Step 1</div>
    </div>
    <div v-show="currentStep >= 2"
         class="cursor-default flex items-center justify-center w-[12.5%] px-1 sm:px-2 lg:px-5 border-r-2 border-red-3">
        <div class="text-white font-semibold">Step 2</div>
    </div>
    <div v-show="currentStep >= 3"
         class="cursor-default flex items-center justify-center w-[12.5%] px-1 sm:px-2 lg:px-5 border-r-2 border-red-3">
        <div class="text-white font-semibold">Step 3</div>
    </div>
    <div v-show="currentStep >= 4"
         class="cursor-default flex items-center justify-center w-[12.5%] px-1 sm:px-2 lg:px-5 border-r-2 border-red-3">
        <div class="text-white font-semibold">Step 4</div>
    </div>
    <div v-show="currentStep >= 5"
         class="cursor-default flex items-center justify-center w-[12.5%] px-1 sm:px-2 lg:px-5 border-r-2 border-red-3">
        <div class="text-white font-semibold">Step 5</div>
    </div>
    <div v-show="currentStep >= 6"
         class="cursor-default flex items-center justify-center w-[12.5%] px-1 sm:px-2 lg:px-5 border-r-2 border-red-3">
        <div class="text-white font-semibold">Step 6</div>
    </div>
    <div v-show="currentStep >= 7"
         class="cursor-default flex items-center justify-center w-[12.5%] px-1 sm:px-2 lg:px-5 border-r-2 border-red-3">
        <div class="text-white font-semibold">Step 7</div>
    </div>
    <div v-show="currentStep >= 8"
         class="cursor-default flex items-center justify-center w-[12.5%] px-1 sm:px-2 lg:px-5 border-r-2 border-red-3">
        <div class="text-white font-semibold">Step 8</div>
    </div>


</template>

<script>
export default {
    props: [
        "currentStep"
    ]
}
</script>
